import React, {Component} from 'react'
import PropTypes from 'prop-types'
import OrderItem from './OrderItem'

class OrdersList extends Component {
    render() {
        const {orders, ...rest} = this.props

        return orders.map(order => <OrderItem key={order._id} {...rest} order={order}/>)
    }
}

OrdersList.propTypes = {
    orders: PropTypes.array.isRequired,
}

export default OrdersList
